// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__9BHfu","question":"Question_question__zCJ9L","description":"Question_description__3sGqa"};